
const INITIAL_STATE = {}

const prdCmbReducer = (state = INITIAL_STATE, action) => {
        switch (action.type) {
                case "GET_DATA_PRDCMB":
                        return { ...state, listaPrdCmb: action.payload.data }
                case "GET_DATA_LSTRVD":
                        return { ...state, ListaTdsRevendas: action.payload.data }
                default:
                        return state
        }
}
export default prdCmbReducer;
